import { type CanvasElementProperties } from '@blaze-runtime/engine-domain';
import { type ViewportMode } from '@blaze-shared/elements-domain';

import { arePropsWithVisibility } from './are-props-with-visibility';

export function getViewportVisibilityFromProps(
  props?: CanvasElementProperties,
): ViewportMode[] | undefined {
  if (!arePropsWithVisibility(props)) {
    return undefined;
  }
  return props.content?.visible?.viewports;
}
